import * as React from "react";

export const ProductSizeIcon = (props: { color: string }) => (
  <svg
    width={13}
    height={12}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.833 10.667h1.334V7.333h-6v-6H1.833v1.334h1.334V4H1.833v1.333h2v1.334h-2V8h1.334v1.333H1.833v1.334h1.334V9.333H4.5v1.334h1.333v-2h1.334v2H8.5V9.333h1.333v1.334ZM6.5 6h5.333a.667.667 0 0 1 .667.667v4.666a.666.666 0 0 1-.667.667H1.167a.666.666 0 0 1-.667-.667V.667A.667.667 0 0 1 1.167 0h4.666A.667.667 0 0 1 6.5.667V6Z"
      fill={props.color}
    />
  </svg>
);
